import { baseApi } from './baseApi';
import { setCredentials, logout } from '../slices/authSlice';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => ({
        url: '/auth/login',
        method: 'POST',
        body,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled.catch(() => ({}));
        if (data) dispatch(setCredentials({ user: data.user, token: data.token }));
      },
    }),
    getMe: builder.query({
      query: () => '/auth/me',
      transformResponse: (response) => response.user,
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: user } = await queryFulfilled;
          dispatch(setCredentials({ user, token: undefined }));
        } catch {
          dispatch(logout());
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useLoginMutation, useGetMeQuery } = authApi;
